export default {
    profile: null,
    fetching: false
};



// WEBPACK FOOTER //
// ./public/pages/Profile/initialState.js